import React, { createContext, useContext } from "react";
import { useTwilioClient } from "../Hooks/use-twilio-client";

const TwilioClientContext = createContext();

const TwilioClientProvider = ({ children }) => {
    const { twilioToken, twilioClient, twilioConversation, unreadCount, getUnreadConversationCount, resetTwilioClient } = useTwilioClient();

    return (
        <TwilioClientContext.Provider value={{
            twilioToken, twilioClient, twilioConversation, unreadCount,
            getUnreadConversationCount, resetTwilioClient
        }}>
            {children}
        </TwilioClientContext.Provider>
    );
};

const useTwilioClientContext = () => {
    const context = useContext(TwilioClientContext);
    if (!context) {
        throw new Error("useTwilioClientContext must be used within TwilioClientProvider");
    }

    return context;
};

export { TwilioClientProvider, useTwilioClientContext };
